import React from "react";
import MotionReveal from "./MotionReveal";
import HomeSectionHeading from "./HomeSectionHeading";
import { resolveHomeIcon } from "./HomeIcons";

export default function HomeWhySection({ content }) {
  const cards = content.cards || [];
  const [featuredCard, ...remainingCards] = cards;
  const secondaryCards = remainingCards.slice(0, 2);
  const supportCards = remainingCards.slice(2, 5);
  const FeaturedIcon = resolveHomeIcon(featuredCard?.icon);

  return (
    <section className="public-home-premium__section public-home-premium__section--mist" id="warum">
      <div className="mx-auto flex w-full max-w-page flex-col gap-10 px-4 sm:px-6 lg:px-8">
        <div className="public-home-premium__why-layout">
          <MotionReveal className="public-home-premium__why-lead-wrap xl:col-span-6" delay={0.04}>
            <article className="public-home-premium__why-lead-card">
              <HomeSectionHeading eyebrow={content.eyebrow} title={content.title} lead={content.lead} className="max-w-none" />

              {featuredCard ? (
                <div className="public-home-premium__why-lead-callout">
                  <span className="public-home-premium__icon-chip">
                    <FeaturedIcon size={18} strokeWidth={1.8} />
                  </span>
                  <div className="flex flex-col gap-3">
                    <span className="public-home-premium__mini-label">Leitdifferenz</span>
                    <h3>{featuredCard.title}</h3>
                    <p>{featuredCard.text}</p>
                  </div>
                </div>
              ) : null}
            </article>
          </MotionReveal>

          <div className="public-home-premium__why-secondary-grid xl:col-span-6">
            {secondaryCards.map((card, index) => {
              const Icon = resolveHomeIcon(card.icon);
              return (
                  <MotionReveal key={card.title} className="public-home-premium__why-card-wrap" delay={0.1 + index * 0.06}>
                  <article className="public-home-premium__why-secondary-card">
                    <div className="flex items-center justify-between gap-4">
                      <span className="public-home-premium__icon-chip">
                        <Icon size={18} strokeWidth={1.8} />
                      </span>
                      <span className="public-home-premium__mini-label">Sekundär</span>
                    </div>
                    <h3>{card.title}</h3>
                    <p>{card.text}</p>
                  </article>
                </MotionReveal>
              );
            })}
          </div>

          <div className="public-home-premium__why-support-grid xl:col-span-12">
            {supportCards.map((card, index) => {
              const Icon = resolveHomeIcon(card.icon);
              return (
                  <MotionReveal key={card.title} className="public-home-premium__why-card-wrap" delay={0.2 + index * 0.05}>
                  <article className="public-home-premium__why-support-card">
                    <div className="flex items-center gap-3">
                      <span className="public-home-premium__icon-chip public-home-premium__icon-chip--small">
                        <Icon size={16} strokeWidth={1.8} />
                      </span>
                      <span className="public-home-premium__mini-label">Stützkachel</span>
                    </div>
                    <h3>{card.title}</h3>
                    <p>{card.text}</p>
                  </article>
                </MotionReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
